import { render } from "./ClassesServices.vue?vue&type=template&id=1a585324&scoped=true"
import script from "./ClassesServices.vue?vue&type=script&lang=js"
export * from "./ClassesServices.vue?vue&type=script&lang=js"

import "./ClassesServices.vue?vue&type=style&index=0&id=1a585324&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a585324"]])

export default __exports__